import React, {useEffect, useState} from 'react';
import Modal from "react-modal";

import './ModalExpired.scss';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        width: '550px',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: "none",
        padding: "0px",
        boxShadow: "0 3px 8px 0 rgba(0, 0, 0, 0.38)",
    }
};

Modal.setAppElement('#root');

const ModalExpired = ({ currentUser, isOpen, onClose}) => {
    const [openModal, setOpenModal] = useState(false);

    useEffect(() => {
        if(!currentUser && isOpen){
            setOpenModal(true);
        }
    }, [currentUser, isOpen])

    const _onActionModal = () => {
        onClose();
        setOpenModal(false);
    };

    if(currentUser){
        return '';
    }

    return (
          <Modal
              shouldCloseOnOverlayClick={false}
              isOpen={openModal}
              onRequestClose={_onActionModal}
              style={customStyles}>
                <div className="modalAlert">
                    <div className="modalBody">
                        <div className="modalIcon">
                          <svg width="53px" height="60px" viewBox="0 0 53 60" version="1.1" xmlns="http://www.w3.org/2000/svg">
                            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                <g transform="translate(-446.000000, -99.000000)">
                                    <g transform="translate(120.000000, 93.000000)"></g>
                                    <g transform="translate(404.000000, 58.000000)">
                                        <g>
                                            <use fill="black" fillOpacity="1" filter="url(#filter-2)"></use>
                                            <use fill="#FFFFFF" fillRule="evenodd"></use>
                                        </g>
                                        <path d="M93.7146652,48.6926758 L68.4008429,41 L43.0870206,48.6926758 C43.0870206,48.6926758 33.9949896,91.9087246 68.4008429,101 C102.805185,91.9087246 93.7146652,48.6926758 93.7146652,48.6926758 Z M63.7244879,82.948922 L51.5247095,70.7491437 L54.195725,68.0781281 L63.7237323,77.6061354 L84.1163879,57.2142353 L86.7874034,59.8852509 L63.7244879,82.948922 Z" id="Shape" fill="#57C892" fillRule="nonzero"></path>
                                    </g>
                                </g>
                            </g>
                        </svg>
                        </div>
                        <div className="modalContent">
                            <div className="_title">
                                Your session timed out.
                            </div>
                            <div className="_subtitle">
                                In order to protect personal and health data, your session was closed after reaching the time limit. Please login again to continue your work.
                            </div>
                        </div>
                        <div className="iconClose">
                            <span className="material-icons" onClick={() => _onActionModal()}>
                                close
                            </span>
                        </div>
                    </div>
                    <div className="modalFooter">
                        <button className="button primary" onClick={() => _onActionModal()}>Login</button>
                    </div>
                </div>
          </Modal>
      )
}

export default ModalExpired;
